import { ApiService } from './api.service'

const baseUrl = '/users'

export const UserService = {
   login (data) {
    return ApiService.post(`${baseUrl}/login`, data).then(response => {
      const { data } = response
      return data
    })
  }
}


